import {io} from 'socket.io-client';
import {HOST} from '../constants';

// eslint-disable-next-line import/no-mutable-exports
export let socket: ReturnType<typeof io> | undefined;
export const createSocketConnection = (query: Record<string, string> = {}, socketToken?: string): void => {
    socket = io(`${HOST}/player/room`, {
        query,
        auth: {token: socketToken},
        autoConnect: false,
        withCredentials: true,
    });
};
